// components/SessionExpiredModal.jsx
import React from "react";
import { Modal, Button } from "antd";

const SessionExpiredModal = ({ open, onConfirm }) => {
  return (
    <Modal
      open={open}
      title="Sitzung abgelaufen"
      closable={false}
      footer={[
        <Button key="confirm" type="primary" onClick={onConfirm}>
          OK
        </Button>,
      ]}
    >
      <p>Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.</p>
    </Modal>
  );
};

export default SessionExpiredModal;
